import digitalIcon from '../assets/digitalIcon.png';
import textIcon from '../assets/textIcon.png';
import picIcon from '../assets/picIcon.png';

export const navList = [
    {
        title: '广告文案创作',
        desc: '支持多类型广告场景',
        icon: textIcon
    },
    {
        title: '数字人',
        desc: '灵活定制数字人视频',
        icon: digitalIcon
    },
    {
        title: '广告图片创作',
        desc: '优质图片一键生成',
        icon: picIcon
    }
];

export const contentList = [
    {
        title: '广告文案创作',
        desc: '基于百度强大AI能力，专注营销广告领域，覆盖信息流、搜索及视频脚本等多场景，以丰富、开放的方式满足文案定制需求',
        wiseDesc: '专注营销广告领域，覆盖信息流、搜索等场景。以丰富、开放的方式满足文案定制需求',
        video: 'http://nadvideo2.baidu.com/demo/text4.mp4',
        hideRole: 'digital_is_passport',
        authorizedRole: 'digital_human_list',
        routeName: 'textCreateWork'
    },
    {
        title: '数字人',
        desc: '国内领先的AIGC生产技术。丰富的数字人模特+专属行业模板+AI脚本创作能力，满足不同营销需求，3分钟实现口播视频制作',
        wiseDesc: '国内领先AIGC技术。丰富的数字人模特+专属行业模板等，3分钟实现口播视频制作',
        video: 'http://nadvideo2.baidu.com/demo/digital4.mp4',
        authorizedRole: 'digital_human_list',
        routeName: 'digitalConsole'
    },
    {
        title: '广告图片创作',
        desc: '完美结合AIGC技术和营销场景。支持文图生成和海报制作等能力，精准满足广告主诉求，打造未来派超级广告图片创作工具',
        wiseDesc: '支持文图生成和海报制作等能力，精准满足广告主诉求。实现AIGC营销场景的完美结合',
        video: 'http://nadvideo2.baidu.com/demo/image4.mp4',
        hideRole: 'digital_is_passport',
        authorizedRole: 'digital_human_list',
        routeName: 'imageCreateWork'
    }
];

export const linkList = [
    {
        title: '营销资源',
        children: [
            {
                target: 'https://yingxiao.baidu.com/new/topic/641/',
                name: '百度APP'
            },
            {
                target: 'https://yingxiao.baidu.com/new/topic/644/',
                name: '百度贴吧'
            },
            {
                target: 'https://yingxiao.baidu.com/new/topic/642/',
                name: '好看视频'
            },
            {
                target: 'https://yingxiao.baidu.com/new/topic/634/',
                name: '百青藤'
            },
            {
                target: 'https://yingxiao.baidu.com/new/topic/643/',
                name: '百度地图'
            },
            {
                target: 'https://yingxiao.baidu.com/new/topic/640/',
                name: '百度聚屏'
            }
        ]
    },
    {
        title: '投放平台',
        children: [
            {
                target: 'https://tuiguang.baidu.com/',
                name: '效果广告投放平台'
            },
            {
                target: 'https://pinpai.baidu.com/',
                name: '品牌广告投放平台'
            }
        ]
    },
    {
        title: '相关营销服务',
        children: [
            {
                target: 'https://qingduo.baidu.com/co-extension-plan',
                name: '共拓计划'
            },
            {
                target: 'https://wutong.baidu.com/platform/',
                name: '基木鱼'
            },
            {
                target: 'https://cdp.baidu.com/',
                name: '观星盘'
            },
            {
                target: 'https://tongji.baidu.com/',
                name: '百度统计'
            },
            {
                target: 'https://b2bwork.baidu.com/',
                name: '爱采购'
            },
            {
                target: 'https://link.baidu.com/',
                name: '度星选'
            },
            {
                target: 'https://yingxiao.baidu.com/edu',
                name: '百度营销学堂'
            },
            {
                target: 'https://e.baidu.com/lp/tongyong7/?refer=1331',
                name: '企业推广'
            }
        ]
    },
    {
        title: '联系我们',
        children: [
            {
                name: 'sy-aigc-cy@baidu.com'
            }
        ]
    }
];